// extracted by mini-css-extract-plugin
export default {"box":"form2_box__4UtKr","input":"form2_input__OcHol"};